import moment from 'moment';

export interface FormItem {
  merchantId?: number;
  merchantName?: string;
  name?: string;
  sellerName?: string;
  contractStatus?: number;
  createTime?: moment.Moment[];
  firstAuditTime?: moment.Moment[];
  merchantPhone?: number;
  platformSuspendStatus?: null | 0 | 1; // 全部：null  0 启用  1 停用
  shopName?: string;
  cityName?: string;
  filterStatus?: string;
  contractRemark?: string;
  auditStatus?: number;
  filterContractStatus?: string;
  merchantType?: number;
  settlementType?: number;
  withdrawalFlag?: number;
  merchantMarginFlag?: string | 0 | 1;
  subjectType?: null | 0 | 1;
  saasAgentId?: string | number; //FIXME: 暂定命名saas归属，需修改
  showTest?: number;
  contractSubject?: string;
  businessManageType?: MANAGE_TYPE;
}

export interface ListItem extends FormItem {
  brandId: number;
  merchantContact: string;
  merchantPhone: number;
  merchantEmail: string;
  ecoPoint: number;
  ecoOrderCount: number;
  shopId: number;
  customerGroupId: number;
  crmDineFlag: number;
  merchantId: number;
  /** 商户名称 */
  merchantName: string;
  /** 商户店铺名称 */
  /** 商户店铺名称 */
  shopName: string;
  /** 商拓销售 */
  sellerName: string;
  /** 合作状态，0:待合作，1:合作中，2:合作过期 */
  contractStatus: CoperateStatusMap;
  /** 商户审核状态，10:待提交初审，11:待初审，12:初审驳回，20:待提交复审，21:待财务审核，22:财务审核驳回，23:财务审核通过，31:待业务审核，32：业务审核驳回 */
  auditStatus: AuditStatus;
  /** 创建时间 */
  createTime: moment.Moment[];
  /** 上线时间 */
  firstAuditTime: moment.Moment[];
  shopContractId: string;
  subShopId: string;
  filterStatus?: string;
  brandName?: string;
  platformSuspendStatus: 0 | 1;
  newAuditStatus: number | null;
  suspendDesc?: string;
  suspendType?: number;
}

export interface ResponseItem {
  total: number;
  list: ListItem[];
  auditStatusCount: any;
  contractStatusCount: any;
  passedUpdateCount: any;
  filterContractStatus: any;
}

export interface BrandListItem {
  brandId: number;
  name: string;
}

export interface FanQuanListItem {
  groupId: number;
  name: string;
}

export interface PostBindBrandParams {
  brandId: number;
  brandName: string;
  merchantInfos: any[];
}

export interface GetBrandListParams {
  name: string;
}

export const contractStatusMap = {
  1: {
    text: '合作中',
    color: '#F79D1E',
    backgroud: 'rgba(247,157,30,0.06)',
  },
  2: {
    text: '合作过期',
    color: '#999',
    backgroud: 'rgba(153,153,153,0.06)',
  },
  default: {
    text: '',
  },
};
export enum CoperateStatusMap {
  /** 待合作 */
  wait,
  /** 合作中 */
  process,
  /** 合作过期 */
  expire,
  all,
}

export enum AuditStatus {
  all = 0,
  /** 待上传证照 */
  wait_pre_submit = 10,
  /** 待初审 */
  wait_pre_audit,
  /** 初审驳回 */
  pre_audit_reject,
  /** 初审通过 */
  pre_audit_pass,
  /** 待提交合同 */
  wait_re_submit = 20,
  /** 待财务审核 */
  wait_re_audit,
  /** 财务驳回 */
  re_audit_reject,
  /** 审核通过（财务审核通过） */
  re_audit_pass,
  /** 待业务审核 */
  re_business_pass = 31,
  /** 业务审核驳回 */
  re_business_reject,
}

export enum AuditStatusText {
  '待完善资料' = AuditStatus.wait_pre_submit,
  '待初审' = AuditStatus.wait_pre_audit,
  '初审通过' = AuditStatus.pre_audit_pass,
  '初审驳回' = AuditStatus.pre_audit_reject,
  '待提交合同' = AuditStatus.wait_re_submit,
  '待财务审核' = AuditStatus.wait_re_audit,
  '财务审核驳回' = AuditStatus.re_audit_reject,
  '审核通过' = AuditStatus.re_audit_pass,
  '待业务审核' = AuditStatus.re_business_pass,
  '业务审核驳回' = AuditStatus.re_business_reject,
}

export interface MerchantListItem {
  merchantId: string;
  /** 商户名称 */
  merchantName: string;
  /** 商户店铺名称 */
  shopId: string;
  /** 商户店铺名称 */
  shopName: string;
  /** 联系人 */
  merchantContact: string;
  /** 联系电话 */
  merchantPhone: number;
  /** 联系邮箱 */
  merchantEmail: string;
  /** 商拓销售 */
  sellerName: string;
  /** 合作状态，0:待合作，1:合作中，2:合作过期 */
  contractStatus: CoperateStatusMap;
  /** 商户审核状态，10:待提交初审，11:待初审，12:初审驳回，20:待提交复审，21:待财务审核，22:财务审核驳回，23:财务审核通过，31:待业务审核，32：业务审核驳回 */
  auditStatus: AuditStatus;
  /** 创建时间 */
  createTime: string;
  /** 上线时间 */
  firstAuditTime: string;
  shopContractId: string;
  subShopId: string;
}
export interface MerchantListSearchParams {
  page: number;
  pageSize: number;
  /** 上线结束时间，毫秒级时间戳  */
  firstAuditTimeEnd?: number;
  /** 上线开始时间，毫秒级时间戳  */
  firstAuditTimeStart?: number;
  /** 创建时间结束，毫秒级时间戳 */
  createTimeEnd?: number;
  /** 创建时间结束，毫秒级时间戳 */
  createTimeStart?: number;
  /** 合作状态，0:待合作，1:合作中，2:合作过期 */
  contractStatus?: CoperateStatusMap;
  /** 商户审核状态，10:待提交初审，11:待初审，12:初审驳回，20:待提交复审，21:待财务审核，22:财务审核驳回，23:财务审核通过，31:待业务审核，32：业务审核驳回 */
  auditStatus?: AuditStatus;
  /** 商拓销售 */
  sellerName?: string;
  /** 商户店铺名称 */
  shopName?: string;
  /** 商户名称 */
  merchantName?: string;
  /** 商户ID */
  merchantId?: string;
  subShopId?: string;
}

// 通过url传参，尽量不要改成number
export enum OPERATE_STATUS {
  /** 新增 */
  add = '0',
  /** 查看 */
  view = '1',
  /** 编辑 */
  edit = '2',
  /** 初审 */
  pre_check = '3',
  /** 财务审核 */
  re_check = '4',
  /** 完善资料 */
  pre_check_submit = '5',
  /** 待业务审核 */
  re_check_submit = '6',
  /** 业务审核 */
  re_business_pass = '7',
  /** 业务审核驳回 */
  re_business_reject = '8',
  /** 财务审核驳回 */
  re_check_reject = '9',
  /** 复制 */
  copy = '10',
}
export enum TitleText {
  '新增合同' = Number(OPERATE_STATUS.add),
  '查看合同' = Number(OPERATE_STATUS.view),
  '编辑合同' = Number(OPERATE_STATUS.edit),
  '业务审核' = Number(OPERATE_STATUS.re_business_pass),
  '财务审核' = Number(OPERATE_STATUS.re_check),
  '复制合同' = Number(OPERATE_STATUS.copy),
}
export enum BREAD_TEXT {
  '新增商户信息' = 0,
  '查看商户信息' = 1,
  '编辑商户信息' = 2,
  '商户信息财务审核' = 3,
  '商户信息完善资料' = 5,
  '商户信息业务审核' = 6,
}

export enum ThirdPlatConfig {
  none,
  candao,
  canxingjian = 5,
  keruyun,
  hualala,
  tiancaishanglong = 16,
}

export enum ContractAuditStatus {
  /** 待运营审核 */
  wait,
  /** 审核通过 */
  pass,
  /** 运营审核驳回 */
  reject,
  /** 待财务审核 */
  financeWait,
  /** 财务审核驳回 */
  financeReject,
  /** 以下两个是纯前端展示的文字 和合同的真实状态无关*/
  /** 待提交审核 纯前端状态 点击合同列表的编辑合同*/
  waitPass,
  /** 查看当前合同 点击合同列表的查看合同*/
  view,
}

export enum ContractAuditStatusText {
  '待运营审核' = ContractAuditStatus.wait,
  '审核通过' = ContractAuditStatus.pass,
  '运营审核驳回' = ContractAuditStatus.reject,
  '待财务审核' = ContractAuditStatus.financeWait,
  '财务审核驳回' = ContractAuditStatus.financeReject,
  /** 以下两个是纯前端展示的文字 和合同的真实状态无关*/
  '待提交审核' = ContractAuditStatus.waitPass,
  '查看合同' = ContractAuditStatus.view,
}

export enum CollectConfig {
  none,
  zhengyuanshouyin,
}

export enum STEPS {
  /** 步骤一 注册商户 */
  base,
  /** 步骤二 资料补齐 */
  merchant,
  /** 步骤三 合同上传 */
  check,
  /** 步骤四 合同审核 */
  final,
}

export enum priceType {
  /** 计价规则  固定计价 */
  fixed,
  /** 计价规则  比例计价 */
  rate,
}

export enum CertificateType {
  /** 默认 */
  default,
  /** 食品经营许可证 */
  food_busi,
  /** 食品生产许可证 */
  food_permi,
  /** 三小类许可证 */
  three_permi,
}

export enum CaculatePrice {
  /** 通用计价 */
  common,
  /** 独立计价 */
  single,
}

export enum CaculatePriceText {
  /** 通用计价 */
  '通用计价' = CaculatePrice.common,
  /** 独立计价 */
  '独立计价' = CaculatePrice.single,
}

export enum SettleMethod {
  /** 组合扣款 */
  combine,
}

export enum SettleMethodText {
  /** 组合扣款 */
  '组合扣款' = SettleMethod.combine,
}

export enum RuleStatus {
  /** 生效 0 */
  effect,
  /** 失效1 */
  off,
}

export enum RuleStatusText {
  '失效' = RuleStatus.off,
  '生效' = RuleStatus.effect,
}

export enum ExtraValueStatus {
  OFF,
  ON,
}

/** 通过url传参，尽量不要改成number */
export enum ContractManagePageOperationType {
  /** 新增合同 */
  add = '0',
  /** 查看合同 */
  view = '1',
  /** 编辑合同 */
  edit = '2',
  /** 编辑并提审合同 */
  edit_to_audit = '3',
  /** 复制合同 */
  copy = '4',
  /** 审核合同 */
  audit = '5',
  /** 业务审核*/
  business_audit = '7',
}

/** 通过url传参，尽量不要改成number */
export enum NewContractManagePageOperationType {
  /** 新增合同 */
  add = '0',
  /** 查看合同 */
  view = '1',
  /** 编辑合同 */
  edit = '2',
  /** 审核合同 */
  audit = '5',
  /** 业务审核*/
  business_audit = '7',
  /** 复制合同 */
  copy = '10',
}

export enum BREAD_TEXT_CONTACT {
  '新增合同' = Number(NewContractManagePageOperationType.add),
  '查看合同' = Number(NewContractManagePageOperationType.view),
  '编辑合同' = Number(NewContractManagePageOperationType.edit),
  '审核合同' = Number(NewContractManagePageOperationType.audit),
  '业务审核' = Number(NewContractManagePageOperationType.business_audit),
  '复制合同' = Number(NewContractManagePageOperationType.copy),
}

export enum ContractStatus {
  /** 待生效 */
  wait,
  /** 生效中 */
  effect,
  /** 合同结束 */
  finish,
  /** 合同终止 */
  stop,
  /** 无法生效 */
  invalid,
  /** 合同未盖章 */
  notsealed,
}
export enum FilterContractStatus {
  /** 合同未盖章 */
  notsealed = 3,
}

export enum ContractStatusText {
  '待生效' = ContractStatus.wait,
  '生效中' = ContractStatus.effect,
  '合同结束' = ContractStatus.finish,
  '合同终止' = ContractStatus.stop,
  '无法生效' = ContractStatus.invalid,
  '合同未盖章' = ContractStatus.notsealed,
}

export enum AuditType {
  /** 初始审核 */
  init,
  /** 修改后审核 */
  modified,
}

export enum AuditTypeText {
  '初始审核' = AuditType.init,
  '修改后审核' = AuditType.modified,
}

export enum ContractSource {
  /** 从商户管理列表入口进入的新增合同 */
  merchant,
  /** 从合同管理列表入口进入的新增合同 */
  contract_list,
}

export enum CoperateStatusText {
  '待合作' = CoperateStatusMap.wait,
  '合作中' = CoperateStatusMap.process,
  '合作过期' = CoperateStatusMap.expire,
}
export enum contractRemarkText {
  '全部' = '',
  '盖章完备' = 1,
  '仅商户盖章' = 2,
  '仅丰食盖章' = 3,
  '无合同' = 4,
  '未到审核流程' = 0,
  '双方盖章完备' = 5,
  '新签商户无合同' = 6,
  '续签商户无合同' = 7,
}
export interface ContractManageListItem {
  /** 商户ID */
  shopId: number;
  /** 门店ID */
  subShopId: number;
  /** 合同id */
  shopContractId: number;
  /** 合同效期开始时间 */
  beginTime: number;
  /** 合同效期结束时间 */
  endTime: number;
  /** 外卖结算费率 */
  serviceRate: number;
  /** 外卖抽佣比例 */
  unionProfitFee: number;
  /** 外卖结算账期 */
  paymentTerms: number;
  /** 自提结算费率 */
  ztServiceRate: number;
  /** 自提抽佣比例 */
  ztUnionProfitFee: number;
  /** 自提结算账期 */
  ztPaymentTerms: number;
  /** 堂食结算费率 */
  tsServiceRate: number;
  /** 堂食抽佣比例 */
  tsUnionProfitFee: number;
  /** 堂食结算账期 */
  tsPaymentTerms: number;
  /** 到店付结算费率 */
  quickpayServiceRate: number;
  /** 到店付抽佣比例 */
  quickpayUnionProfitFee: number;
  /** 到店付打款时间/结算账期 */
  quickpayPaymentTerms: number;
  /** 批量设置结算账期 */
  batchSet: number;
  /** 履约终止时间 */
  suspendTime: number;
  /** 计价模板 0:通用计价 1:独立计价 */
  valuationType: CaculatePrice;
  /** 履约开始时间 */
  performanceBeginTime: number;
  /** 履约结束时间 */
  performanceEndTime: number;
  /** 物流欠款上限 */
  minBalance: number;
  /** 结算方式 0:组合扣款 */
  settlementMethod: SettleMethod;
  /** 初始审核状态 0:待审核 1:审核通过 2:审核驳回 */
  auditStatus: ContractAuditStatus;
  /** 审核时间 */
  auditTime: number;
  /** 合同状态 0待生效  1:生效中  2:合同结束   3:合同终止  4:无法生效 */
  status: ContractStatus;
  /** 是否终止 0:否 1:是 */
  isSuspend: number;
  /** 最新审核状态：0:待审核 1:审核通过 2:审核驳回 */
  newAuditStatus: ContractAuditStatus;
  /** 从哪个入口创建的合同，0:商户列表提交 1:合同列表新增 */
  source: ContractSource;
  /** 合同日志审核类型，0:初始审核，1:修改后审核 */
  logAuditType: AuditType;
  /** 外卖结算账期周期 0：固定天数（D）；1：固定日期（M）*/
  splitAccountType: Number;
  /** 自提结算账期周期 0：固定天数（D）；1：固定日期（M）*/
  ztSplitAccountType: Number;
  /** 堂食结算账期周期 0：固定天数（D）；1：固定日期（M）*/
  tsSplitAccountType: Number;
  /** 到店付结算账期周期 0：固定天数（D）；1：固定日期（M）*/
  quickpaySplitAccountType: Number;
  /** 结算方式 1是差价 2是抽佣*/
  settlementType: number;
  /** 商户类型 0餐饮，1商户*/
  merchantType: number;
}

export enum DealStatus {
  default,
  handling,
  done,
}

export enum remarkStatus {
  '未到合同流程' = 0,
  '盖章完备' = 1,
  '仅商户盖章' = 2,
  '仅丰食盖章' = 3,
  '无合同' = 4,
  '双方盖章完备' = 5,
  '新签商户无合同' = 6,
  '续签商户无合同' = 7,
}
export enum deliveryTypeEnum {
  Platform,
  Merchant,
}
export enum deliveryTypeEnumText {
  '平台配送' = deliveryTypeEnum.Platform,
  '商户自配' = deliveryTypeEnum.Merchant,
}
export enum ValuationTypeEnum {
  Fix,
  Ratio,
}
export enum ValuationTypeEnumText {
  '固定计价' = ValuationTypeEnum.Fix,
  '比例计价' = ValuationTypeEnum.Ratio,
}
export interface RuleDetailItem {
  ruleId?: number;
  ruleDetailId?: number;
  deliveryType: deliveryTypeEnum;
  valuationType: ValuationTypeEnum;
  absoluteValuationFee?: number;
  relativeValuationRatio?: number;
  orderPriceExtraValuationStatus: number | boolean; // 固定计价大额单费用开启状态,0：关闭，1：开启
  orderPriceExtraValuationPer?: number;
}
export enum MerchantType {
  /** 餐饮商户 */
  canyin,
  /** 商城商户 */
  shangcheng,
}
export enum MerchantTypeOptions {
  '商城商户' = MerchantType.shangcheng,
  '餐饮商户' = MerchantType.canyin,
}

export interface IRecord {
  /**
   * 提交人id
   */
  submitOperator?: string;
  /**
   * 提交人姓名
   */
  submitOperatorName?: string;
  /**
   * 提交人时间
   */
  createTime?: string;
  /**
   * 运营审核时间
   */
  businessAuditTime?: string;
  /**
   * 运营审核人id
   */
  businessOperator?: string;
  /**
   * 运营审核人姓名
   */
  businessOperatorName?: string;
  /**
   * 财务审核时间
   */
  financeAuditTime?: string;
  /**
   * 财务审核人id
   */
  financeOperator?: string;
  /**
   * 财务审核人姓名
   */
  financeOperatorName?: string;
  /**
   * 历史版本id
   */
  contractLogId?: string;
  /**
   * 0:待业务审核 1:审核通过 2:业务审核驳回 3：待财务审核  4：财务审核驳回
   */
  auditStatus: ContractAuditStatus;
  /**
   * 驳回原因
   */
  rejectReason?: string;
  [k: string]: unknown;
}

export enum isOpenStatus {
  '未开通' = 0,
  '已开通' = 1,
}

//  经营类型
export enum MANAGE_TYPE {
  //  餐饮
  FOOD = 0,
  //  商超
  SHOP = 1,
}
